module.exports = __webpack_public_path__ + "img/android_icon.69837ff5.svg";